import { render, staticRenderFns } from "./products-view.vue?vue&type=template&id=23474736&scoped=true&lang=pug"
import script from "./products-view.js?vue&type=script&lang=js&external"
export * from "./products-view.js?vue&type=script&lang=js&external"
import style0 from "./products-view.vue?vue&type=style&index=0&id=23474736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23474736",
  null
  
)

export default component.exports